import { ITENS_MENU } from "./sidebar";
import { SessaoUsuario } from "../api/auth";

export function renderTopbar(rotaAtiva: string, sessao: SessaoUsuario): string {
  const item = ITENS_MENU.find((i) => i.rota === rotaAtiva);
  return `
    <header class="topbar">
      <div class="topbar__titulo">${item ? item.rotulo : ""}</div>
      <div class="topbar__usuario">
        ${sessao.email} — <a href="#" id="botao-sair">sair</a>
      </div>
    </header>
  `;
}
